import { store } from '$lib/utilities/store';
import { get } from 'svelte/store';

export const getPdfTags = async (file) => {
	// 1) Dynamic import of the ESM module
	const module = await import(/* @vite-ignore */ 'pdfjs-dist/legacy/build/pdf.mjs');

	// 2) Point to the worker (also .mjs)
	module.GlobalWorkerOptions.workerSrc = new URL(
		'pdfjs-dist/legacy/build/pdf.worker.mjs',
		import.meta.url
	).href;

	// 3) Load & parse your PDF
	const res = await fetch(file.templateUrl);
	const buffer = await res.arrayBuffer();
	const loadingTask = module.getDocument({ data: buffer });
	const pdf = await loadingTask.promise;

	const currentStore = get(store).settings;
	const signatureFields = (currentStore?.docs?.['FormSubmission 01 Envelopes']?.section?.value?.signatureFields?.value || '').split(', ');

	let tags = '';
	const fieldLocations = {};
	let leftMargin = null;  // we're gonna use this to track the minimum X of all text items.
	let signatureTags = [];
	const signatureLocations = {};
	const signatureDateLocations = {};
	for (let i = 0; i < pdf.numPages; i++) {
		const page = await pdf.getPage(i + 1);
		const textContent = await page.getTextContent();

		for (const item of textContent.items) {
			if (leftMargin === null) {
				leftMargin = item.transform[4];
			} else {
				if (item.transform[4] < leftMargin) {
					leftMargin = item.transform[4];
				}
			}

			const fields = item.str
				.split('<<')
				.filter((e) => e.includes('>>'))
				.map((e) => e.split('>>')[0].trim());

			for (const field of fields) {
				if (!signatureFields.includes(field)) {
					if (!fieldLocations[field]) {
						if (tags !== '') {
							tags += '-|-';
						}
						tags += field;
						fieldLocations[field] = [];
					}
					fieldLocations[field].push({
						page: i + 1,
						X: item.transform[4],
						Y: item.transform[5],
						textHeight: item.height || 0,
						textWidth: item.width || 0
					});
				} else {
					const locations = field.endsWith(' SIGNATURE DATE') ? signatureDateLocations : signatureLocations;
					if (!locations[field]) {
						signatureTags.push(field);
						locations[field] = [];
					}
					locations[field].push({
						page: i + 1,
						X: item.transform[4],
						Y: item.transform[5],
						textHeight: item.height || 0,
						textWidth: item.width || 0
					});
				}
			}
		}
		const annots = await page.getAnnotations({ intent: 'display' });
		if (annots) {
			for (const field of annots) {
				// TODO: add these to the tags string and fieldLocations
				console.log({ field });
			}
		}
	}

	const { PDFDocument } = await import('pdf-lib');
	const newRes = await fetch(file.templateUrl);
	const newBuffer = await newRes.arrayBuffer();
	const pdfLibDoc = await PDFDocument.load(newBuffer);
	if (pdfLibDoc.getForm) {
		const formFields = pdfLibDoc.getForm().getFields();
		for (const field of formFields) {
			// TODO: add these to the tags string and fieldLocations
			console.log({ field });
		}
	}

	console.log({ tags, fieldLocations, leftMargin, signatureTags, signatureLocations, signatureDateLocations });
	return { tags, fieldLocations, leftMargin, signatureTags, signatureLocations, signatureDateLocations };
};
